// import format from "date-fns/format";
// import { enAU } from "date-fns/locale";
// const DATE_FORMAT_MAPPINGS = {
//   /** 19/11/2000 */
//   short: "P",
//   /** Nov 19, 2000 */
//   medium: "PP",
//   /** November 19th, 2000 */
//   long: "PPP",
//   /** November 2000 */
//   month_year: "MMMM yyyy",
// } as const;
// type DateFormatTypes = keyof typeof DATE_FORMAT_MAPPINGS;
// export function formatDate(value: Date, type: DateFormatTypes = "short") {
//   return format(value, DATE_FORMAT_MAPPINGS[type], { locale: enAU });
// }
import "dayjs/locale/en-au";
import dayjs from "dayjs";
import LocalisedFormat from "dayjs/plugin/localizedFormat";
dayjs.extend(LocalisedFormat);
dayjs.locale("en-au");
var DATE_FORMAT_MAPPINGS = {
    /** 19/11/2000 */ short: "L",
    /** Nov 19, 2000 */ medium: "MMM D, YYYY",
    /** November 19th, 2000 */ long: "LL",
    /** November 2000 */ month_year: "MMMM YYYY"
};
export function formatDate(value) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "short";
    return dayjs(value).format(DATE_FORMAT_MAPPINGS[type]);
}
